import React from 'react';
import { branch, compose, lifecycle, withProps, renderNothing } from 'recompose';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';


import {
  canUserViewCustomReports,
  canUserEditCustomReports,
} from '../../../../../common/helpers/users';
import {
  getReportDefinitions,
  isReportDefinitionsFetched,
  isReportDefinitionsError,
} from '../../selectors';
import { fetchReportDefinitions } from '../../actions';
import DropdownMenu from '../../../../../common/DropdownMenu';
import CustomReportsDropdown from './CustomReportsDropdown';
import { getBrandId, getShopBrandId } from '../../../../../auth/selectors';

const enhance = compose(
  withRouter,
  connect(
    state => ({
      items: getReportDefinitions(state),
      fetched: isReportDefinitionsFetched(state),
      error: isReportDefinitionsError(state),
      canViewCustomReports: canUserViewCustomReports(state),
      canEditCustomReports: canUserEditCustomReports(state),
      brandId: getBrandId(state) || getShopBrandId(state),
    }),
    ({ fetchReportDefinitions }),
  ),
  withProps(props => ({
    pathname: props.router.location.pathname,
    WrapperComponent: props.mobile ? React.Fragment : DropdownMenu,
  })),
  branch(
    props => !props.canViewCustomReports,
    renderNothing,
  ),
  lifecycle({
    componentWillMount() {
      if (!this.props.fetched) {
        this.props.fetchReportDefinitions(this.props.brandId);
      }
    },
  }),
);

export default enhance(CustomReportsDropdown);
